<template>
  <div class="search-input">
    <form action="/">
      <van-search
        v-model="value"
        shape="round"
        :placeholder="holder"
        @search="onSearch"
      />
    </form>
  </div>
</template>

<script>
export default {
  name: "SearchInput",
  props: {
    holder: {
      default: "请输入关键字查询",
    },
  },
  data() {
    return {
      value: "",
    };
  },
  methods: {
    onSearch(val) {
      this.$emit("search", val);
    },
  },
};
</script>

<style>
.van-search{
  padding: 0 20px;
}
</style>
